import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormModule } from '@coreui/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxPrintModule } from 'ngx-print';
import { TokenService } from 'src/app/configurazioni/jwt.service';
import { environment } from 'src/environments/environment';
import { PazientiService } from '../services/pazienti.service';

@Component({
  selector: 'app-form-preview',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule,FormModule,NgxPrintModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './form-preview.component.html',
  styleUrl: './form-preview.component.scss'
})
export class FormPreviewComponent {

  @Input('form')form: any;
  @ViewChild('printSection',{static:true})printSection: ElementRef | undefined;
  @ViewChild('scheda')cambioForm: any;
  @Output() submitEvent = new EventEmitter<any>(); // Aggiunto l'EventEmitter

  context: any=environment.betterContextReadonly;
  credentials: any=environment.credentials;
  resourceUrl=environment.betterResourceUrl;
  @Input() cambia:boolean=false;
  betterEnvirorment={
    variables: [
      {
        name: 'ehrId',
        value: ''
      }
    ]
  };
  @Input('ehrId')ehrId:any;
  @Input('compositionId')compositionId:any;
  constructor(private readonly  tokenService:TokenService,private pazienteService:PazientiService) { 
   
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log(changes)
    if (changes['context'] && !changes['context'].isFirstChange()) {
      console.log("Context cambiato:", this.context);

    }
  }
  ngOnInit(){
    this.credentials.token=this.tokenService.getToken();
    if (this.betterEnvirorment && this.betterEnvirorment.variables[0]) {
      this.betterEnvirorment.variables[0].value = this.ehrId || '';
    
    }
  }
  async onSubmit() {
    const scriptApi = this.cambioForm!.nativeElement.getScriptApi();
    
   
    
    // Chiama la funzione di aggiornamento
    const response=await scriptApi.updateComposition();
    console.log(response)
    if(response.success){
      let compositionNew=response.commitData[0].id
      this.compositionId=compositionNew;
      this.pazienteService.getPazienteByEhrId(this.ehrId).subscribe(res=>{
        res.allergieId=compositionNew
        this.pazienteService.updatePaziente(res).subscribe(res=>{
       
          this.submitEvent.emit({ success: true, compositionId: this.compositionId });
          
        })
      })
    }
}
  async onSave() {
  const scriptApi = this.cambioForm!.nativeElement.getScriptApi();
    
   
    
  // Chiama la funzione di aggiornamento
  const response=await scriptApi.saveComposition();
  console.log(response)
  if(response.success){
    let compositionNew=response.commitData[0].id
    this.compositionId=compositionNew;
    this.pazienteService.getPazienteByEhrId(this.ehrId).subscribe(res=>{
      res.allergieId=compositionNew
      this.pazienteService.updatePaziente(res).subscribe(res=>{
     
        this.submitEvent.emit({ success: true, compositionId: this.compositionId });
        
      })
    })
  }  }

}
